import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            aria-hidden='true'
            className={cn('size-8 shrink-0', className)}
        >
            <rect width='32' height='32' rx='9' className='fill-primary' />

            <g className='stroke-primary-foreground' strokeWidth='2.6' strokeLinecap='round'>
                <path d='M10 9.5v13' />
                <path d='M14 9.5v13' />
                <path d='M18 9.5v13' />
                <path d='M22 9.5v13' />
            </g>

            <path d='M6.5 20.5 25.5 11.5' className='stroke-accent' strokeWidth='2.8' strokeLinecap='round' />
        </svg>
    )
}

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span className='font-heading text-xl font-bold tracking-tight'>
                Tallyho
            </span>
        </span>
    )
}
